import React, { useState } from 'react';
import Sidebar from './components/Layout/Sidebar';
import MainContent from './components/Layout/MainContent';
import UsersPanel from './components/Admin/UsersPanel';
import ConsultantsPanel from './components/Admin/ConsultantsPanel';
import './App.scss'

const App = () => {
  const [view, setView] = useState('calendar');

  const renderView = () => {
    if (view === 'users') return <UsersPanel />;
    if (view === 'consultants') return <ConsultantsPanel />;
    return <MainContent />;
  };

  return (
    <Sidebar view={view} setView={setView}>
      {renderView()}
    </Sidebar>
  );
};

export default App;
